export const SOFT_SKILL_CAT = 1;
export const ADVANCE_SKILL_CAT = 2;
export const EXAM_REVIEW_CAT = 3;
export const IT__CAT = 4;
export const ENGLISH_CAT = 5;
export const CHINESE_CAT = 6;

export const CATEGORIES_DATA = [
    {
      id: SOFT_SKILL_CAT,
      name: "Kỹ năng mềm",
    },
    {
      id: ADVANCE_SKILL_CAT,
      name: "Kỹ năng chuyển môn",
    },
    {
      id: EXAM_REVIEW_CAT,
      name: "Ôn thi học kỳ",
    },
    {
      id: IT__CAT,
      name: "Tin học",
    },
    {
      id: ENGLISH_CAT,
      name: "Tiếng anh",
    },
    {
      id: CHINESE_CAT,
      name: "Tiếng trung",
    },
  ];

export const CLUB_CATEGORY = 1;
export const PROJECT_CATEGORY = 2;
export const COMPETITION_CATEGORY = 3;
export const SCHOOLARSHIP_CATEGORY = 4;
export const EVENT_CATEGORY = 5;
export const YOURSELF_EVALUATION_CATEGORY = 6;
export const JOB_EVALUATION_CATEGORY = 7;
  
export const NEWS_CATEGORY = 1;
export const USER_CATEGORY = 2;